<div [class.se-ui-datagrid-boolean_box_editor]="!disabled()" [class.se-ui-datagrid-boolean_box_overlay]="disabled()">
    @if (editor() === "CHECKBOX") {
        <mat-checkbox
            #checkbox
            class="se-ui-datagrid-boolean_box"
            [class.se-ui-datagrid-boolean_box_renderer_index]="disabled()"
            [formControl]="formControl"
            [color]="color()"
        >
        </mat-checkbox>
    } @else if (editor() === "SLIDETOGGLE") {
        <mat-slide-toggle
            #slideToggle
            class="se-ui-datagrid-boolean_box"
            [class.se-ui-datagrid-boolean_box_renderer_index]="disabled()"
            [formControl]="formControl"
            [color]="color()"
        >
        </mat-slide-toggle>
    }
</div>
